module.exports = __webpack_public_path__ + "static/task-cards-3164c6c7a697db063b4d7d6f64fe95f6.svg";